import { interviewApi } from "@/features/interview/interviewApi";
import interviewFlowReducer from "@/store/interviewFlowSlice";
import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";

export const store = configureStore({
  reducer: {
    [interviewApi.reducerPath]: interviewApi.reducer,
    interviewFlow: interviewFlowReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(interviewApi.middleware),
  // Enable Redux DevTools in development mode
  devTools: process.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
